import { QueryClient } from '@tanstack/react-query';

import { ApiClientError } from '../lib/api-client.js';

/**
 * Creates the TanStack Query client. Kept as a factory so tests get an isolated instance.
 */
export function createQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30_000,
                // Do not hammer the API for client errors; network errors still retry a little.
                retry: (failureCount, error) => {
                    if (error instanceof ApiClientError && error.status < 500) {
                        return false;
                    }
                    return failureCount < 2;
                },
                refetchOnWindowFocus: true,
            },
        },
    });
}
